import { atom } from 'recoil'
import { makeEncoderAdapterFactory } from '@/main/adapters'

export const encoderAdapterAtom = atom({
  key: 'encoderAdapterAtom',
  default: makeEncoderAdapterFactory()
})
